import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import CustomerList from '../components/customer-list/customer-list'
import dataLoad from '../actions/data-load';
import onSearchClearCustomerList from '../actions/onSearchClearCustomerList';

function mapStateToProps(state) {
    // console.log("state are >>>>>", state)
  return {
    customerListing: state.customerList.customerListing,
    pageNo: state.customerList.pageNo,
    customer: state.customer,
    customerCount: state.customerCount,
    ajaxStatuses: state.ajaxStatuses.dataLoad,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dataLoad,
    onSearchClearCustomerList,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);